import React from "react";
import { createRoot } from "reactdom";
import App from "../components/TabsBlock/App";

const renderTabsBlock = ($) => {
	const tabsBlock = $("#js-tabs-block")[0];

	if (tabsBlock) {
		const root = createRoot(tabsBlock);
		
		let props = {
			...(tabsBlock && tabsBlock.dataset),
		};

		root.render(<App {...props} />);
	}
};

export default renderTabsBlock;
